import { useTranslation } from 'react-i18next';

import Button from 'components/Buttons';

import * as Styled from './ErrorContent.styles';

type ErrorContentProps = {
  onRetry: () => void;
};

function ErrorContent({ onRetry }: ErrorContentProps) {
  const { t } = useTranslation();

  return (
    <Styled.Background>
      <Styled.Message>{t('errorBoundary.warning')}</Styled.Message>
      <Button type="primary" onClick={() => onRetry()}>
        {t('errorBoundary.retry')}
      </Button>
    </Styled.Background>
  );
}

export default ErrorContent;
